import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import DropZone from 'react-dropzone';
import Modal from 'react-modal';
import { modalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { formatDate } from '../../utils/';
import { fetchFactSheets } from '../../actions/project_actions';
import FactSheetViewForm from './FactSheetViewForm';

class FactSheet extends Component {

    constructor(props) {
        super(props);

        this.state = {
            factSheetVisible: true,
            factSheet: props.factSheet,
            isLoading: false,
            isLoadingInitial: false,
            warning: false,
            warningDescr: false,
            warningScope: false,
            warningTitle: false,
            modalVisible: false,

            charsLeftDescr: 0,
            charsLeftScope: 0,
            charsLeftTitle: 0,
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.showViewForm = this.showViewForm.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.errorHandler = this.errorHandler.bind(this);
        this.onDone = this.onDone.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.fetchFactSheets(this.props.projectId);
        this.setState({ isLoadingInitial: true })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ factSheet: nextProps.factSheet })
        this.setState({ isLoadingInitial: false })

        this.setState({ charsLeftDescr: 1000 - nextProps.factSheet.projectDescription.length })
        this.setState({ charsLeftScope: 2000 - nextProps.factSheet.scopeOfWork.length })
        
        if (nextProps.factSheet.factSheetTitle) {
            this.setState({ charsLeftTitle: 50 - nextProps.factSheet.factSheetTitle.length })
        }
    }

    onDrop(files) {
        if (files !== undefined && files[0] !== undefined) {
            if (files[0].size < 6291456) {
                const factSheet = this.state.factSheet;
                let id = 0;

                if (factSheet.image != null) {
                    id = factSheet.image.id;

                    factSheet.image = files[0];

                    const reader = new FileReader();
                    reader.readAsDataURL(factSheet.image);

                    reader.onload = () => {
                        factSheet.image.base64 = reader.result;
                        factSheet.image.id = id;
                        factSheet.image.contentType = factSheet.image.type;
                        factSheet.image.contentLength = factSheet.image.size;
                        factSheet.image.fileName = factSheet.image.name;
                        factSheet.image.blobUrl = factSheet.image.preview;

                        this.setState({
                            factSheet
                        });
                    }

                    this.setState({ showErr: false});
                }
            }
        }
    }

    onDropRejected() {
        this.setState ({modalVisible: true});
      }

    showViewForm(toEdit) {
        this.setState({ factSheetVisible: !this.state.factSheetVisible });
    }

    handleChange(field) {
        return (e) => {
            const factSheet = this.state.factSheet;
            factSheet[field] = e.target.value;
            this.setState({ factSheet });
        };
    }

    handleChangeNumLeft(field, maxLength) {
        return (e) => {
            const factSheet = this.state.factSheet;
            factSheet[field] = e.target.value;
            this.setState({ factSheet });

            if (maxLength === 1000) {
                this.setState({
                    charsLeftDescr: maxLength - e.target.value.length
                });
            }
            else if (maxLength === 2000) {
                this.setState({
                    charsLeftScope: maxLength - e.target.value.length
                });
            }
            else if (maxLength === 50) {
                this.setState({
                    charsLeftTitle: maxLength - e.target.value.length
                });
            } 
        };
    }

    handleSubmit(e) {
        e.preventDefault();

        const { roleModules } = this.props.permissions.editPrivileges;

        const canEdit = roleModules !== null && roleModules.includes('Fact sheet') 
        ? true : false;

        this.setState({ warning: false, warningDescr: false, warningScope: false, warningTitle: false });

        if (canEdit) this.saveHandler();
    }

    saveHandler() {
        const factSheet = this.state.factSheet;
        const { projectId } = this.props;

        this.setState ({ isLoading: true })

        factSheet.image = {
            contentType: factSheet.image.type,
            contentLength: factSheet.image.size,
            fileName: factSheet.image.name,
            blobUrl: factSheet.image.preview,
            base64: factSheet.image.base64,
            id: factSheet.image.id,
        }

        let method = 'post';
        let url = `projects/${projectId}/factSheets`;

        return this.makePutOrPostRequest(factSheet, method, url);
    }

    makePutOrPostRequest(factSheet, method, url) {
        const { projectId } = this.props;
        factSheet.projectId = projectId;

        if (this.state.charsLeftDescr < 0) {
            this.setState({ warningDescr: true });
            this.setState ({ isLoading: false })
        }

        else if (this.state.charsLeftScope < 0) {
            this.setState({ warningScope: true });
            this.setState ({ isLoading: false })
        }

        else if (this.state.charsLeftTitle < 0) {
            this.setState({ warningTitle: true });
            this.setState ({ isLoading: false })
        }
             
        else {
            withAuth(
                { method, url, data: factSheet },
                () => {
                    this.props.fetchFactSheets(projectId);
                    this.setState ({ isLoading: false })
                    this.showViewForm(factSheet);
                },
                this.errorHandler
            )
        }
    }

    errorHandler (error) {
        this.setState ({ isLoading: false, warning: true })
      }

      onDone() {
        this.setState({modalVisible: false});
      }

    render() {
        const { factSheetVisible, factSheet, warning, warningDescr, warningScope, warningTitle } = this.state;
        const { info, schedule, members, projectId } = this.props;
        const { roleModules } = this.props.permissions.editPrivileges;
       console.log(members);
        const canEdit = roleModules !== null && roleModules.includes('Fact sheet') 
        ? true : false;

        let warningMsg = '';
        if (warning)
            warningMsg = 'Save failed. Image size should be less than 6MB.';
        else if (warningDescr)
            warningMsg = 'Save failed. Please reduce Project Description field to 1000 characters.';
        else if (warningScope)
            warningMsg = 'Save failed. Please reduce Project Scope field to 2000 characters.';
        else if (warningTitle)
            warningMsg = 'Save failed. Please reduce Title field to 50 characters.';

        return (
            <div className="container">

                {this.state.isLoadingInitial ?
                    <div className="loader" /> : null}

                {this.state.modalVisible
                    && <Modal
                        isOpen={this.state.modalVisible}
                        style={modalStyle}
                        contentLabel="Upload error"
                    >
                        <h1>Maximum file upload size is 6MB</h1>
                        <div className="modal-close" onClick={this.onDone}>
                            <span className="close"></span>
                        </div>
                    </Modal>
                }

                {factSheetVisible ? null
                    : <div className="row margin-top-2 no-print">
                        <button className="btn-save margin-left-275 margin-top-075" onClick={() => this.showViewForm()}>
                            Edit</button>
                    </div>}

                {factSheetVisible && canEdit ?
                <div>
                    <div className="row no-print">
                        <div className="col l6 m6 s12">
                            <button onClick={() => this.showViewForm()}>
                                <span className="print-preview-link">PRINT PREVIEW</span>
                            </button>
                        </div>
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <div>
                            <div className="fact-sheet">

                                    <div className="controls text-center">
                                        <label>Title
                                    <span className="color-green"> (maximum size is 50 characters)</span>
                                            <span className="count-down-label">Characters remaining: <span className="color-green">{this.state.charsLeftTitle}</span></span>
                                        </label>
                                        <textarea name="factSheetTitle" rows="1" value={factSheet.factSheetTitle}
                                            onChange={this.handleChangeNumLeft('factSheetTitle', 50)} maxLength="50" className="height-auto text-center">
                                        </textarea>
                                    </div>

                                <div className="row">
                                    <div className="col s12">
                                        <h4 className="text-center">{info.fmsids.join(', ')}</h4>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col l4 m6">
                                        <div className="controls padding-bottom-0">
                                            <span className="label underline">Client:</span>
                                        </div>
                                        <div className="controls">
                                            <label>City Agency</label>
                                            <input type="text" name="clientAgency" value={factSheet.clientAgency} maxLength="50"
                                                onChange={this.handleChange('clientAgency')} />
                                        </div>
                                        <div className="controls">
                                            <label>Commissioner</label>
                                            <input type="text" name="comissioner" value={factSheet.comissioner} maxLength="50"
                                                onChange={this.handleChange('comissioner')} />
                                        </div>
                                        <div className="controls">
                                            <label>Assistant Commissioner</label>
                                            <input type="text" name="assistantComissioner" value={factSheet.assistantComissioner} maxLength="50"
                                                onChange={this.handleChange('assistantComissioner')} />
                                        </div>
                                        <div className="controls">
                                            <label>Location</label>
                                            <input type="text" name="address1" value={factSheet.address1} maxLength="50"
                                                onChange={this.handleChange('address1')} />
                                            <input type="text" name="address2" value={factSheet.address2} maxLength="50"
                                                onChange={this.handleChange('address2')} />
                                            <input type="number" name="zipCode" value={factSheet.zipCode} maxLength="50"
                                                onChange={this.handleChange('zipCode')} />
                                        </div>
                                        <div className="controls padding-bottom-0">
                                            <span className="label underline">Size:</span>
                                        </div>
                                        <div className="controls">
                                            <label>Lot Area </label>
                                            <input type="text" name="lotSize" value={factSheet.lotSize} maxLength="50"
                                                onChange={this.handleChange('lotSize')} />
                                             <label>New Building Area</label>
                                            <input type="text" name="buildingAreaSize" value={factSheet.buildingAreaSize} maxLength="50"
                                                onChange={this.handleChange('buildingAreaSize')} />
                                        </div>

                                        {schedule.designStart.actual === null && schedule.designStart.projected === null &&
                                            schedule.designCompletion.actual === null && schedule.designCompletion.projected === null &&
                                            schedule.constructionStart.actual === null && schedule.constructionStart.projected === null &&
                                            schedule.constructionCompletion.actual === null && schedule.constructionCompletion.projected === null             
                                            ? null :
                                            <div className="controls">
                                                <span className="label">Schedule</span>
                                                {schedule.designStart.actual !== null
                                                    ? <span className="value">Actual Design Start: {formatDate(schedule.designStart.actual)}</span>
                                                    : <span className="value">Projected Design Start: {formatDate(schedule.designStart.projected)}</span>
                                                }
                                                {schedule.designCompletion.actual !== null
                                                    ? <span className="value">Actual Design Completion: {formatDate(schedule.designCompletion.actual)}</span>
                                                    : <span className="value">Projected Design Completion: {formatDate(schedule.designCompletion.projected)}</span>
                                                }
                                                {schedule.constructionStart.actual !== null
                                                    ? <span className="value">Actual Construction Start: {formatDate(schedule.constructionStart.actual)}</span>
                                                    : <span className="value">Projected Construction Start: {formatDate(schedule.constructionStart.projected)}</span>
                                                }
                                                {schedule.constructionCompletion.actual !== null
                                                    ? <span className="value">Actual Construction Completion: {formatDate(schedule.constructionCompletion.actual)}</span>
                                                    : <span className="value">Projected Construction Completion: {formatDate(schedule.constructionCompletion.projected)}</span>
                                                }
                                            </div>}

                                        <div className="controls">
                                            <label>Budget Construction</label>
                                            <span className="display-inline">$</span>
                                            <input type="number" name="budgetConstruction" value={factSheet.budgetConstruction} step="any" min="0"
                                              maxLength="50"  onChange={this.handleChange('budgetConstruction')} />
                                        </div>
                                        <div className="controls">
                                            <label>Projected Construction</label>
                                            <span className="display-inline">$</span>
                                            <input type="number" name="budgetProjectedConstruction" value={factSheet.budgetProjectedConstruction} step="any" min="0"
                                             maxLength="50"   onChange={this.handleChange('budgetProjectedConstruction')} />
                                        </div>
                                        <div className="controls">
                                            <label>Design Consultants</label>
                                            <input type="text" name="designConsultant" value={factSheet.designConsultant} maxLength="50"
                                                onChange={this.handleChange('designConsultant')} />
                                        </div>
                                        <div className="controls">
                                            <label>Construction Management</label>
                                            <input type="text" name="constructionMgmt" value={factSheet.constructionMgmt} maxLength="50"
                                                onChange={this.handleChange('constructionMgmt')} />
                                        </div>

                                        <div className="controls">
                                            <label>Contractors</label>
                                            <input type="text" name="contractor" value={factSheet.contractor} maxLength="2000"
                                                onChange={this.handleChange('contractor')} />
                                        </div>

                                        {members.length > 0 ?
                                            <div className="controls">
                                                <span className="label">DDC Team</span>
                                                {members.map(member =>
                                                    <span key={member.id} className="value">{member.projectTitle.title}: {member.member.firstName}  {member.member.lastName}</span>
                                                )}
                                            </div>
                                            : null}

                                        <div className="controls">
                                            <label>Borough President</label>
                                            <input type="text" name="boroughPresident" value={factSheet.boroughPresident} maxLength="50"
                                                onChange={this.handleChange('boroughPresident')} />
                                        </div>
                                        <div className="controls">
                                            <label>Community Board</label>
                                            <input type="text" name="communityBoard" value={factSheet.communityBoard} maxLength="50"
                                                onChange={this.handleChange('communityBoard')} />
                                        </div>
                                        <div className="controls">
                                            <label>Council Member</label>
                                            <input type="text" name="councilMember" value={factSheet.councilMember} maxLength="50"
                                                onChange={this.handleChange('councilMember')} />
                                        </div>
                                        <div className="controls">
                                            <label>City Council District</label>
                                            <input type="text" name="cityCouncilDistrict" value={factSheet.cityCouncilDistrict} maxLength="50"
                                                onChange={this.handleChange('cityCouncilDistrict')} />
                                        </div>
                                        <div className="controls">
                                            <label>Business Improvement District</label>
                                            <input type="text" name="businessImprovementDistrict" value={factSheet.businessImprovementDistrict} maxLength="50"
                                                onChange={this.handleChange('businessImprovementDistrict')} />
                                        </div>

                                        <div className="controls">
                                                <span className="label">Last Update By</span>                                             
                                                    <span className="value">{factSheet.modifiedUserUniqueName}</span>                                            
                                            </div>
                                            <div className="controls">
                                                <span className="label">Last Update Date</span>                                             
                                                    <span className="value">{formatDate(factSheet.modifiedDate)}</span>                                            
                                            </div>
                                    </div>

                                    <div className="col l8 m6">
                                        <div className="controls">
                                            <label>Project Description <span className="color-green"> (maximum size is 1000 characters)</span>
                                                <span className="count-down-label">Characters remaining: <span className="color-green">{this.state.charsLeftDescr}</span></span>
                                            </label>
                                            <textarea name="projectDescription" rows="5" value={factSheet.projectDescription} maxLength="1000"
                                                onChange={this.handleChangeNumLeft('projectDescription', 1000)}>
                                            </textarea>
                                        </div>
                                        <div className="controls">
                                            <label>Scope of Work  <span className="color-green"> (maximum size is 2000 characters)</span>
                                                <span className="count-down-label">Characters remaining: <span className="color-green">{this.state.charsLeftScope}</span></span>
                                            </label>
                                           <pre className="open-sans"> <textarea name="scopeOfWork" rows="5" value={factSheet.scopeOfWork} maxLength="2000"
                                                onChange={this.handleChangeNumLeft('scopeOfWork', 2000)}>
                                            </textarea> </pre>
                                        </div>
                                        <div className="upload-area">
                                            <DropZone
                                                className="dropzone"
                                                multiple={false}
                                                accept="image/*"
                                                maxSize={6291456}
                                                onDropRejected={this.onDropRejected.bind(this)}
                                                onDrop={this.onDrop.bind(this)}>
                                                DROP HERE or CLICK, to add files:
                                                <span className="color-green">&nbsp;PNG, JPEG, JPG, GIF, BMP, ICO</span> formats allowed.
                                                Maximum file size:  <span className="color-green">6MB.</span>
                                            </DropZone>
                                        </div>
                                        {_.isEmpty(factSheet.image) ? null : <img src={factSheet.image.base64} alt="fact sheet" />}                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <button className="btn-save margin-left-275" disabled={this.state.isLoading}>{'Save'}</button>
                        </div> 
                    </form>
                 </div>

                    : <FactSheetViewForm
                        factSheet={factSheet}
                        schedule={schedule}
                        members={members}
                        projectId={projectId}
                        info={info}
                    />}

                {this.state.isLoading ? <div>
                    <div className="loader" />
                    <p className="padding-left-2 margin-left-075 label-color">Please wait</p>
                </div> : null}

                {this.state.showErr &&
                    <div>
                        <p className="padding-left-2 margin-left-075 color-orange">Please upload an image</p>
                    </div>
                }

                 {warningMsg !== '' ?
                    <div>
                        <p className="padding-left-2 margin-left-075 color-orange">{warningMsg}</p>
                    </div> : null} 

            </div>
        );
    }
}

FactSheet.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired,
    factSheet: PropTypes.object.isRequired,
    fetchFactSheets: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        projectId: ownProps.projectId,
        info: state.projectsStore.info,
        schedule: state.projectsStore.schedule,
        members: state.projectsStore.members,
        permissions: state.projectsStore.permissions,
        factSheet: state.projectsStore.factSheet,
    };
}

export default connect(mapStateToProps, {
    fetchFactSheets,
})(FactSheet);